import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import '../App.css';
import '../index.css';
import MusicLogTableEntry from "./MusicLogTableEntry";
import LogTableMarker from "./LogTableMarker";
import Titlebar from "../Titlebar";

// a little function to help us with reordering the result
const moveItem = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 1;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid,
  margin: `0 0 ${grid}px 0`,
  fontWeight: "bold", 
  borderRadius: "0.375rem",

  // change background colour if dragging
  color: isDragging ? "white" : "black",
  background: isDragging ? "lightgreen" : "white",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getMarkerStyle = () => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid,
    margin: `0 0 ${grid}px 0`,
    fontWeight: "bold", 
  
    // change background colour if dragging
    color: "grey",
  });


class MusicLogTable extends Component {
  constructor(props) {
    super(props);

    let items = [];

    // Fix the condition - check if logdata exists and has stats property
    if (props.logdata && props.logdata.stats && Array.isArray(props.logdata.stats)) {
      for (let i = 0; i < props.logdata.stats.length; i++) {
          const logEntry = { ...props.logdata.stats[i] };
          logEntry.idx = (i + 48).toString();
          items.push(logEntry);
      }

      items.sort((a, b) => (a.count < b.count) ? 1 : -1);
    }

    this.state = {
        items: items
    };

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  // Add componentDidUpdate to handle prop changes
  componentDidUpdate(prevProps) {
    // Check if logdata prop has changed
    if (prevProps.logdata !== this.props.logdata) {
      // Create a fresh copy of getItems
      let items = [];
      
      if (this.props.logdata && this.props.logdata.stats && Array.isArray(this.props.logdata.stats)) {
        // Process the new logdata
        for (let i = 0; i < this.props.logdata.stats.length; i++) {
          const logEntry = { ...this.props.logdata.stats[i] }; // Create a copy
          logEntry.idx = (i + 48).toString();
          items.push(logEntry);
        }
        
        // Sort items by count (descending)
        items.sort((a, b) => (a.count < b.count) ? 1 : -1);
      }
            
      // Update state with new items
      this.setState({ items: items });
    }
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    let draggedItem = this.state.items[result.source.index];
    if (draggedItem.type === 'marker') {
      return;
    }

    // return if the spot is dragged above the 00 marker 
    if (result.destination.index === 0) {
        return;
    }   

    // We need to reorder the list and regenerate the time marker for the placed spot. 
    const items = moveItem(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    // seek the earliest marker above the placed spot
    let markerIndex = 0;
    for (let i = result.destination.index - 1; i >= 0; i--) {
        if (items[i].type === 'marker') {
            markerIndex = i;
            break;
        }
    }
    // update the time marker for the placed spot
    let time = items[markerIndex].time;
    // console.log(time);
    // detect if the time is on the hour or half hour
    let timeArray = time.split(':');
    let minutes = parseInt(timeArray[1]);
    
    if (minutes === 0) {
        time = timeArray[0] + ':13:00';
    } else {
        time = (parseInt(timeArray[0])).toString().padStart(2, '0') + ':43:00';
    }
    items[result.destination.index].time_of_day = time;
    
    this.setState({
      items
    });
  }

  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  render() {
    return (
    <div className="lg:pl-72 sm:ml-0 px-0 sm:px-0">
      {
        this.props.showtitlebar !== false && 
        <Titlebar title="Music Logs"/>
      }

      <div className="mx-4 my-4 lg:px-4 rounded-md">
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div 
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
       {this.state.items && this.state.items.length > 0 ? (
                    this.state.items.map((item, index) => (
                      <Draggable key={item.idx} draggableId={item.idx} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                          {(
                          item.type === 'marker' ?
                          <LogTableMarker index={index} marker={item}
                          style={getMarkerStyle()}
                          />
                          :
                            <MusicLogTableEntry                       
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                            logentry={item} index={index} 
                            />
                          )}
                          </div>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <div className="text-center py-8 text-gray-500">
                      No music log data available
                    </div>
                  )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      </div>
      </div>
    );
  }
}

export default MusicLogTable;